import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/onlinePayment/complete', request)
}

export {post}
